import { useContext, useEffect } from 'react';
import { toast } from 'sonner';
import { PreferencesContext } from 'context/PreferencesProvider';
import { useGetUser } from 'hooks';

export const useAGLOCampaign = () => {
  const { isAGLO, user, activeOrganizationId, activeRole } = useGetUser();
  const campaign = useContext(PreferencesContext);
  const { campaignYear, isHistoricalCampaign, isCampaignSwitching } = campaign;
  const selectedCampaignYear = campaign.selectedCampaignYear ?? campaignYear;
  const params = isAGLO && isHistoricalCampaign ? { campaign_year: selectedCampaignYear } : {};
  const scope = isAGLO ? [selectedCampaignYear, campaignYear, user?.id, activeOrganizationId, activeRole] : [];
  return {
    ...campaign,
    selectedCampaignYear,
    isAGLO,
    params,
    scope,
    isReadOnly: isHistoricalCampaign || isCampaignSwitching,
  };
};

export const useCampaignSwitchStatus = (queries) => {
  const { isAGLO, campaignSwitch, selectedCampaignYear, finishCampaignSwitch, rejectCampaignSwitch } =
    useAGLOCampaign();
  useEffect(() => {
    if (!isAGLO || !campaignSwitch || campaignSwitch.to !== Number(selectedCampaignYear)) return;
    const failed = queries.some(({ isError, data, isPreviousData }) => isError && (!data || isPreviousData));
    const ready = queries.every(
      ({ isFetching, data, isPreviousData }) => !isFetching && !isPreviousData && data !== undefined
    );
    if (failed) {
      rejectCampaignSwitch(selectedCampaignYear);
      toast.error('Impossible de charger cette campagne.');
    } else if (ready) {
      finishCampaignSwitch(selectedCampaignYear);
    }
  }, [campaignSwitch, finishCampaignSwitch, isAGLO, queries, rejectCampaignSwitch, selectedCampaignYear]);
};
